import React from 'react';
import { Link } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';
import '../styles/aboutComponent.css';

const highlights = [
  { value: '10+', label: 'Satisfied Clients' },
  { value: '10+', label: 'Core Services' },
  { value: '24/7', label: 'Support Available' },
  { value: '5+', label: 'Years Combined Experience' },
];

function About() {
  return (
    <section className="about-home" id="about">
      <div className="container">
        <div className="about-home-grid">
          <ScrollReveal className="about-home-copy">
            <p className="section-eyebrow">About QASHQ</p>

            <h2 className="about-home-title">
              Business expertise and technology capability — under one roof.
            </h2>

            <p className="about-home-lead">
              QASHQ is not simply an accounting firm or a software agency. We are a Business &amp; IT
              consulting company built to help organizations make smarter decisions and build stronger
              operations.
            </p>

            <p className="about-home-body">
              From financial reporting and compliance to custom software and digital transformation, we
              deliver integrated solutions with the professionalism, clarity, and reliability that growing
              businesses deserve.
            </p>

            <div className="about-home-actions">
              <Link to="/about" className="btn btn-secondary about-home-btn-primary">
                Learn About QASHQ
              </Link>
              <Link to="/contact" className="btn btn-outline about-home-btn-secondary">
                Get in Touch
              </Link>
            </div>
          </ScrollReveal>

          <div className="about-home-stats" aria-label="QASHQ highlights">
            {highlights.map((item, index) => (
              <ScrollReveal
                key={item.label}
                as="article"
                className="about-home-stat"
                delay={index * 0.07}
              >
                <span className="about-home-stat__value">{item.value}</span>
                <span className="about-home-stat__label">{item.label}</span>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
